module.exports = __webpack_public_path__ + "img/facebook.28069975.svg";